/*! THIS PROJECT IS NOT DONE, NOR OPTIMIZED */
import { Item } from "dsabp-js"
import "./main.js"

export * from "./BpRenderer.js"
export { connectedTileTypes } from "./renderers/Tile.js"
export * from "./util.js"

export let imagesPath: string = ""
export function setImagesPath(path: string) {
	imagesPath = path
}

export let customImagePathHandler: (path: string) => string
export function setCustomImagePathHandler(fn: typeof customImagePathHandler) {
	customImagePathHandler = fn
}

// some workarounds
Item.DOOR.buildInfo.splice(0, 2, { bounds: { x: 0.45, y: 2 }, snap_x: true, snap_y: true, offset: { x: 0, y: 0.5 }, image: "door_full", build_angle: "Fixed", image_only: true })
Item.ITEM_LAUNCHER.buildInfo[0].build_angle = "Any"
Item.RCD_FLUX.buildInfo[0].build_angle = "Any"
Item.RCD_SANDBOX.buildInfo[0].build_angle = "Any"
